var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottombite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.1,242.4c-7.5,8.7-3.3,22.5,8,26c1.6,0.5,3,0.7,4.5,0c1.3-0.7,2.3-2.3,4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.6,300.9c2.4,2.9,5.3,3.1,8.5,1.5c4.1-2,8.7-3,12-6.5c2.2-2.4,2.6-5.4,0.4-7.4c-3.6-3.1-6.2-7.2-9.9-10.1 c-2.5-2-5.2-4.6-8.5-3.8c-4.2,1-4.2,5.6-4.4,8.8c-0.3,4.8-0.9,9.7,0.8,14.5c1.6,4.5-0.9,8.5-5.9,9.4c-3.3,0.6-6.7,0.4-10,0.6 c-3.3,0.2-5.1-1.5-6-4.5c0,0-0.2-2.1,0-4.1c0-0.6,0.5-1.7,0.5-2.6c0.1-5.6,2.1-10.7,4.1-15.8c0.7-1.7,1-4.1,3.4-4.5 c2.7-0.5,3.8,1.6,5,3.5c1.1,1.8,2.2,3.5,3.1,5.5c1.1,2.4,1.6,5.2,3.9,7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.1,289.9c5.5,1.5,10.7,0.1,16-1.4c2.1-0.6,2.7-1.7,3.4-3.2c1.1-2.1,2.1-4.3,3-6.5c2.9-7.2-0.3-12.8-8-15.1 c-3.6-1.1-6.8-3.1-10.5-4c-6.4-1.5-9.4,0.6-9.5,7.1c-0.1,5.6,0.4,10.9,2.9,16.1c0.5,1,1.4,2.6,0.1,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.1,212.4c-5.9,3.7-7.8,14.2-3.4,21.4c1.4,2.3,2.8,4.9,5.3,6.7c5,3.5,9.8,1.5,14.5-0.2c3-1,5.6-2.9,9-3 c6.1-0.2,10.5,2.4,13.5,8.6c2.7,5.7,2.1,9.5-2.5,14.5c-0.8,0.9-1.9,1.6-1.5,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.1,161.4c1.7-0.8,3.3-1.7,5-2.5c7.2-3.3,9.9-9.2,8.3-16.5c-1-4.4-1.2-8.7-2-13 c-1.2-6.7-6.1-11.1-12.8-11.9c-8.6-0.9-17.1,0.5-25,4.3c-8.6,4.2-8.6,12.5-4.8,19.4c1.2,2.3,1.5,3.6,1,6.1 c-1.7,9,4.2,16.8,12.8,16.1c7.9-0.6,16-0.1,24-0.1c9.2,0,14.9,5.5,14.9,14.5c0,2.1,0.7,3.8,1.6,5.5c4.4,8.9,3.2,14-5,20 c-2,1.5-4.3,2.7-6.5,4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.1,165.4c3.4,1.6,6.9,2.8,10,5c4.7,3.3,8.1,9.8,3.3,16.9c-2.4,3.5-2.9,6.8-2.8,10.6 c0,7.7-4.8,12.1-12.5,12.6c-5.4,0.4-10.4-0.2-15.5-1.5c-8.5-2.2-17.2,5-18.1,13.9c-0.6,5.8,1.4,10.3,5.6,14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.1,242.4c7.5,8.6,3.2,22.5-8,26c-1.6,0.5-3,0.7-4.5,0c-1.3-0.7-2.3-2.3-4-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.6,207.4c-3.4-2.2-7.2-3.8-10.1-6.9c-3.9-4.2-5.1-8.9-2.9-14c1.6-3.7,2.9-7.3,3.1-11.5 c0.3-6.3,7-11.4,13.8-11.5c8.3-0.1,16.7-0.5,25,0.1c9,0.7,14.5-7.5,12.8-16.6c-0.3-1.7-0.9-2.8,0.1-4.6c7.3-12.3,1.7-19.3-8.5-22.4 c-7.3-2.2-14.7-4-22.5-1.7c-5.4,1.6-9,4.3-10,10.1c-0.9,5.2-2.2,10.3-2.9,15.5c-1.3,9.3,3.7,13.3,11.9,16.5c0.5,0.2,1,0.7,1.5,1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.6,300.9c-2.4,2.9-5.3,3.1-8.5,1.5c-2.1-1.1-4.3-2-6.5-3c-2.9-1.3-6-2.5-7-6c-1-3.6,1.3-5.7,3.9-7.5 c0.6-0.5,1-1.4,1.5-2c3-3,5.7-6.4,9.5-8.5c4.2-2.3,6.8-1,8,4c1.4,6.2,1.8,12.3,0,18.5c-1.3,4.5,0.2,8.2,6,9.4 c3.2,0.7,6.6,0.4,10,0.6c3.3,0.2,5.6-1.7,6.5-4.7c0,0,0.5-1.8,0-3.4c-1.9-5.5-1.8-11.5-4.5-16.9c-0.2-0.4,0.2-1.2-0.1-1.4 c-1.6-1.5-1.3-4.6-4-5c-3.1-0.5-4.1,2.1-5.5,4c-2.8,3.6-3.2,8.6-6.5,12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.6,286.9c-1.3-4,1.6-7.3,2.3-10.9c0.7-3.9,0.6-7.7,0.6-11.6c0-2.8-2.1-4.6-4.9-5 c-3.7-0.5-7.5,0.5-10.4,2.2c-4.1,2.3-10,1.9-12.3,7.7c-1.2,3.1-2.9,5.6-0.4,8.6c0.1,0.1,0,0.4,0,0.5c2.1,4.4,2.4,10.2,9,11 c4.5,0.5,8.9,2.1,13.5,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.1,236.9c6.3-5.2,7-12,4.4-19c-2.8-7.5-11.6-11.4-19.8-8.3c-5.6,2.1-10.8,0.5-16.1,0.6 c-4.1,0.1-8.9-6.1-8.9-10.8c0-4.7-0.4-8.9-3.4-13.1c-3.6-5.1-1.6-11.6,3.3-15.4c3.2-2.5,7-3.7,10.5-5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.1,212.4c5.9,3.7,7.8,14.2,3.4,21.4c-1.4,2.3-2.8,4.9-5.3,6.7c-5,3.5-9.8,1.5-14.5-0.2c-3-1-5.6-2.9-9-3 c-6.1-0.2-10.5,2.4-13.5,8.6c-2.7,5.7-2.1,9.5,2.5,14.5c0.8,0.9,1.9,1.6,1.5,3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottombite);
export default __webpack_public_path__ + "static/media/Bottombite.542b1b7d3a32fd5c5020ef749cbc7502.svg";
export { ForwardRef as ReactComponent };